<div class="dialog-container">
  <div
    mat-dialog-title
    class="close-div"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle
  >
    <h4>Rulebook update review</h4>
    <div class="title-actions">
      @if (showToggle) {
        <mat-button-toggle-group
          class="view-toggle-group"
          [value]="sigOnly ? 'sig' : 'all'"
          (change)="onViewChange($event.value)"
        >
          <mat-button-toggle value="sig" [disabled]="loading">
            Significant Only
          </mat-button-toggle>
          <mat-button-toggle value="all" [disabled]="loading">
            All Changes
          </mat-button-toggle>
        </mat-button-toggle-group>
      }
      <button
        mat-button
        [mat-dialog-close]=""
        (click)="onClose()"
        cdkFocusInitial
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <div
    mat-dialog-content
    class="update-review dialog-content"
    #reviewContent
  >
    @if (loading) {
      <div class="review-loading">Loading...</div>
    } @else {
      @for (sc of sections; track sc) {
      <div>
        <h4 class="sectionTitle">
          Section&nbsp;{{sc.rbSectNum}}:&nbsp;{{sc.rbSectName}}
        </h4>
        @for (p of sc.para; track p) {
        <div class="para">
          <div class="b">Para&nbsp;{{p.paraNum}}</div>
          <div>Question: <span [innerHTML]="p.newQuestion"></span></div>
          <br />
          <div [innerHTML]="p.newGuidenote"></div>
          <br />
        </div>
        }
      </div>
      }
    }
  </div>
  <div mat-dialog-actions>
    <div>
      <button mat-button (click)="onPrint()" class="button-close">
        Print
      </button>
      <button
        mat-button
        (click)="onRemoveFlag()"
        class="button-close"
        cdkFocusInitial
      >
        Remove flag
      </button>
      <button
        mat-button
        (click)="onClose()"
        mat-dialog-close
        class="button-close"
      >
        Close
      </button>
    </div>
  </div>
</div>
